import React, { useState, useEffect } from "react";
import { Button, FormGroup } from "reactstrap";
import { FaPaperPlane, FaTimes } from "react-icons/fa";
import Drop from "./dropzoneSingle.js";
import axios from "./axios-config";
import swal from "./i18n/swal";
import ReactDOM from "react-dom";
import { Spinner } from "react-bootstrap";

function DocPendientes({ numeroGestion, tipoGestion }) {
  const [files, setFiles] = useState([]);

  const EnviarDigitalizacion = () => {
    // Crear un div para insertar el spinner React
    const container = document.createElement("div");
    // Renderizar el spinner React dentro del div
    ReactDOM.render(
      <Spinner
        animation="border"
        size="md"
        style={{ color: "#872434" }}
        className="me-2"
      />,
      container
    );
    swal({
      title: "Procesando...",
      text: "Por favor, espera mientras procesamos la información.",
      icon: "info",
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
      // Opcional: para poner un gif o animación personalizada,
      // puedes incluir HTML con imagen
      content: container,
    });

    let formData = new FormData();
    if (window.datoArchivoN[0]?.length == 0) {
      swal("Importante", "Para continuar, debe seleccionar al menos un archivo", "warning");
      return;
    }
    formData.append(
      "gestion",
      JSON.stringify({
        idGestion: numeroGestion,
        tipoGestion: tipoGestion, // 1 reclamo, 2 autorizacion
      })
    );

    for (var i = 0; i < window.datoArchivoN[0].length; i++) {
      formData.append(
        "listaArchivos",
        window.datoArchivoN[0][i],
        window.datoArchivoN[0][i].name
      );
    }
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/digitalizarGestion/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
          },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          swal({
            title: "¡Completado!",
            text: response.data.mensaje,
            icon: "success",
            buttons: {
              confirm: "OK",
            },
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
          window.datoArchivoN = [];
        }
      })
      .catch((error) => {
        console.error("Error en la petición:", error);
        // Intenta obtener el mensaje de error del servidor, si existe
        const mensajeError =
          error.response?.data?.mensaje ||
          error.message ||
          "Ocurrió un error inesperado.";

        swal({
          title: "Error",
          text: mensajeError,
          icon: "error",
          button: "Aceptar",
        });
      });
  };

  const mostrarDigitalizacion = () => {
    var element = document.getElementById("drop");
    var estado = element.style.display;
    if (estado == "none") {
      element.style.display = "block";
    } else {
      element.style.display = "none";
    }
  };

  return (
    <>
      <Drop />
      <hr />
      <div>
        <FormGroup className="form-actions">
          <Button
            type="submit"
            size="sm"
            onClick={EnviarDigitalizacion}
            style={{ backgroundColor: "rgb(0, 52, 121)" }}
          >
            <FaPaperPlane /> Enviar
          </Button>

          <Button
            type="submit"
            size="sm"
            onClick={mostrarDigitalizacion}
            style={{ marginLeft: "10px", backgroundColor: "rgb(135, 36, 52)" }}
          >
            <FaTimes /> Cerrar
          </Button>
        </FormGroup>
      </div>
      <br />
    </>
  );
}
export default DocPendientes;
